<template>
  <div class="l-count">
    <el-input v-if="!printMode" v-model="value2" placeholder="" readonly></el-input>
    <span v-else class="showText">{{value2}}</span>
  </div>
</template>
<script>
export default {
  name: "l-count",
  props: {
    value: [Number, String],
    formatJson: {
      type: Array,
      default: function () {
        return [];
      },
    },
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    decimal: {},
    thousandSeparator: {},
    isChinese: {},
    printMode: {
      default: false
    },
  },
  data() {
    return {};
  },
  computed: {
    value2: {
      get: function get() {
        var _this = this,
          json = "",
          formatJson = this.formatJson,
          val;
        formatJson.map(function (e) {
          if ("fun" == e.type && "(" !== e.name && ")" !== e.name)
            if (["abs", "max", "min", "sqrt"].includes(e.name))
              json += "Math.".concat(e.name);
            else if (["int", "power", "rand"].includes(e.name))
              switch (e.name) {
                case "int":
                  json += "Math.floor";
                  break;
                case "power":
                  json += "Math.pow";
                  break;
                case "rand":
                  json += "Math.random";
                  break;
              }
            else
              switch (e.name) {
                case "average":
                  json += "this.averageFun";
                  break;
                case "ceiling":
                  json += "this.ceilingFun";
                  break;
                case "count":
                  json += "this.countFun";
                  break;
                case "countif":
                  json += "this.countifFun";
                  break;
                case "fixed":
                  json += "this.fixedFun";
                  break;
                case "floor":
                  json += "this.floorFun";
                  break;
                case "large":
                  json += "this.largeFun";
                  break;
                case "log":
                  json += "this.logFun";
                  break;
                case "mod":
                  json += "this.modFun";
                  break;
                case "product":
                  json += "this.productFun";
                  break;
                case "round":
                  json += "this.roundFun";
                  break;
                case "small":
                  json += "this.smallFun";
                  break;
                case "sum":
                  json += "this.sumFun";
                  break;
                case "sumproduct":
                  json += "this.sumproductFun";
                  break;
              }
          else if ("comp" === e.type)
            if (e.tableId) {
              var t = _this.formData[e.tableId].map(function (t) {
                return t[e.name];
              });
              (json = "".concat(json, "[")),
                t.map(function (e, t) {
                  var n = _this.$deepClone(e) || 0,
                    r = /[\u4e00-\u9fa5a-zA-Z]/.test(_this.$deepClone(e));
                  json = r
                    ? 0 == t
                      ? "".concat(json, '"').concat(n, '"')
                      : "".concat(json, ',"').concat(n, '"')
                    : 0 == t
                    ? "".concat(json).concat(n)
                    : "".concat(json, ",").concat(n);
                }),
                (json = "".concat(json, "]"));
            } else {
              var n = _this.$deepClone(_this.formData[e.name]);
              _this.$validatenull(n) ||
                (/[\u4e00-\u9fa5a-zA-Z]/g.test(n) && (n = '"' + n + '"')),
                (json += n || 0);
            }
          else json += e.name;
        });
        try {
          val = eval(json);
        } catch (_unused) {
          return (
            this.$message({
              type: "warning",
              message: this.$t("计算失败"),
            }),
            ""
          );
        }
        return (
          void 0 !== this.decimal && (val = val.toFixed(this.decimal)),
          this.thousandSeparator &&
            (val = val
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")),
          this.isChinese && (val = this.intToChinese(val)),
          val
        );
      },
      set: function () {},
    },
  },
  watch: {
    value2: {
      handler: function (e) {
        this.$emit("input", e), this.$emit("change", e);
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.animation) {
      this.init();
    }
  },
  methods: {
    intToChinese: function (e) {
      if (!/^\d*(\.\d*)?$/.test(e)) return "Number is wrong!";
      for (
        var t = new Array(
            "零",
            "壹",
            "贰",
            "叁",
            "肆",
            "伍",
            "陆",
            "柒",
            "捌",
            "玖"
          ),
          n = new Array("", "十", "百", "千", "万", "亿", "点", ""),
          r = ("" + e).replace(/(^0*)/g, "").split("."),
          i = 0,
          o = "",
          a = r[0].length - 1;
        a >= 0;
        a--
      ) {
        switch (i) {
          case 0:
            o = n[7] + o;
            break;
          case 4:
            new RegExp("0{4}\\d{" + (r[0].length - a - 1) + "}$").test(r[0]) ||
              (o = n[4] + o);
            break;
          case 8:
            (o = n[5] + o), (n[7] = n[5]), (i = 0);
            break;
        }
        i % 4 == 2 &&
          0 != r[0].charAt(a + 2) &&
          0 == r[0].charAt(a + 1) &&
          (o = t[0] + o),
          0 != r[0].charAt(a) && (o = t[r[0].charAt(a)] + n[i % 4] + o),
          i++;
      }
      if (r.length > 1) {
        o += n[6];
        for (var l = 0; l < r[1].length; l++) o += t[r[1].charAt(l)];
      }
      return o;
    },
    averageFun: function () {
      for (var e = 0, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return (
        n.map(function (t) {
          e += t;
        }),
        e / n.length
      );
    },
    ceilingFun: function (e, t) {
      return t < 0
        ? -Math.ceil(e / Math.abs(t)) * t || 0
        : Math.ceil(e / t) * t || 0;
    },
    countFun: function () {
      return arguments.length;
    },
    countifFun: function countifFun(arr, condition) {
      var count = 0;
      if (Array.isArray(arr))
        if (/[><=]/.test(condition))
          for (var i = 0; i < arr.length; i++)
            try {
              eval(arr[i] + condition) && count++;
            } catch (_unused2) {
              this.$message({
                type: "warning",
                message: this.$t("计算失败"),
              });
              break;
            }
        else
          arr.map(function (e) {
            e == condition && count++;
          });
      return count;
    },
    fixedFun: function (e, t) {
      var n = e.toFixed(t);
      return n;
    },
    floorFun: function (e, t) {
      return t < 0
        ? -Math.floor(e / Math.abs(t)) * t || 0
        : Math.floor(e / t) * t || 0;
    },
    largeFun: function (e, t) {
      if (Array.isArray(e))
        return (
          e.sort(function (e, t) {
            return t - e;
          }),
          e[t - 1]
        );
    },
    smallFun: function (e, t) {
      if (Array.isArray(e))
        return (
          e.sort(function (e, t) {
            return e - t;
          }),
          e[t - 1]
        );
    },
    logFun: function (e, t) {
      return Math.log(e) / Math.log(t);
    },
    modFun: function (e, t) {
      return e % t;
    },
    productFun: function () {
      for (var e = 1, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return (
        n.map(function (t) {
          e *= t;
        }),
        e
      );
    },
    roundFun: function (e, t) {
      var n = e.toFixed(t);
      return Number(n);
    },
    sumFun: function () {
      for (var e = 0, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return (
        n.map(function (t) {
          e += t;
        }),
        e
      );
    },
    sumproductFun: function () {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
        t[n] = arguments[n];
      var r = t[0].map(function (e, n) {
          for (var r = e, i = 1; i < t.length; i++) r *= t[i][n] || 0;
          return r;
        }),
        i = r.reduce(function (e, t) {
          return e + t;
        }, 0);
      return i;
    },
  },
};
</script>